import { render, staticRenderFns } from "./PNGModalBlock.vue?vue&type=template&id=22cdc7fe"
import script from "./PNGModalBlock.vue?vue&type=script&lang=js"
export * from "./PNGModalBlock.vue?vue&type=script&lang=js"
import style0 from "./PNGModalBlock.vue?vue&type=style&index=0&id=22cdc7fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports